import React, { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useVendorProvider } from "../../../../Providers/Client/Vendor";
import CustomTable from "../../../../Components/Table";
import { stringAvatar } from "../../../../Utils/avatar";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../../Utils/constants";

const headCells = [
  { id: "firstName", numeric: false, disablePadding: false, label: "Vendors" },
  { id: "status", numeric: false, disablePadding: false, label: "Status" },
];

export default function CurrentVendors() {
  const { vendors, fetchVendors, acceptRequest, declineRequest } =
    useVendorProvider();
  const permissions = useSelector((state) => state.user.permissions);
  useEffect(() => {
    if (
      permissions?.includes(`admin-client`) ||
      permissions?.includes(userPermissions.vendorConnection.view)
    ) {
      fetchVendors();
    }
  }, []);

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover tabIndex={-1} key={row.id}>
        <TableCell align="left">
          <Link target="_blank" to={`/vendor/profile/${row.fromid || row.id}`}>
            <div className="flex items-center">
              <Avatar
                {...stringAvatar(
                  row.companyName
                    ? row.companyName
                    : row.firstName
                    ? `${row.firstName} ${row.lastName}`
                    : row.email
                )}
                className="mr-2.5"
                size="large"
                src={row?.profilePhoto}
              />
              <span>
                {row.companyName
                  ? row.companyName
                  : row.firstName
                  ? `${row.firstName} ${row.lastName}`
                  : row.email}
              </span>
            </div>
          </Link>
        </TableCell>
        <TableCell align="left">
          {row.status === "Requested" && row.from === "VENDOR" ? (
            permissions?.includes(userPermissions.vendorConnection.add) ? (
              <div className="flex gap-x-4">
                <button
                  className="bg-green-400 text-white px-2 py-1 rounded-md"
                  onClick={() => acceptRequest(row.id)}
                >
                  Accept
                </button>
                <button
                  className="bg-red-400 text-white px-2 py-1 rounded-md"
                  onClick={() => declineRequest(row.id)}
                >
                  Reject
                </button>
              </div>
            ) : null
          ) : (
            row.status
          )}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <CustomTable
      title="Vendors"
      headCells={headCells}
      rows={vendors}
      CustomRow={CustomRow}
    />
  );
}
